import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export const SignalCellularConnectedNoInternet4BarIcon = React.forwardRef<HTMLSpanElement, IconProps>((props, ref) => {
    return <Icon {...props} iconKey={"signal_cellular_connected_no_internet_4_bar"} ref={ref}/>
});

SignalCellularConnectedNoInternet4BarIcon.displayName = "SignalCellularConnectedNoInternet4BarIcon";
